import { render, staticRenderFns } from "./UpdateMGate.vue?vue&type=template&id=a19cb990"
import script from "./UpdateMGate.vue?vue&type=script&lang=js"
export * from "./UpdateMGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports